// Power Action
export const ENTER_POWER_LOAD = 'footer/ENTER_POWER_LOAD';
export const ENTER_POWER_SUCCESS = 'footer/ENTER_POWER_SUCCESS';
export const ENTER_POWER_FAIL = 'footer/ENTER_POWER_FAIL';
